import React from "react";
import loadable from "@loadable/component";
import CenterSpinner from "../../common/centerSpinner";

function AsyncAccountManagerEdit({ ...rest }) {
  const AsyncLoad = loadable(() => import("../page/accountManagerEdit"));
  console.log("Loading", AsyncAccountManagerEdit.name);
  return <AsyncLoad {...rest} fallback={<CenterSpinner />} />;
}

export default AsyncAccountManagerEdit;
